export default {
  parentCorps (state) {
      return state.parentCorps
    },
    selectedParentCorp (state) {
        return state.selectedParentCorp
    },
    getParentCorpUserList (state) {
      return state.parentCorpUserList
    },
    getParentCorp: state => (id) => {
      return state.parentCorps.find(item => item.parentAccountId == id)
    }
}



// WEBPACK FOOTER //
// ./src/store/modules/parentCorporations/getters.js